import { common } from './common';
import { sidebar } from './sidebar';
import { dashboard } from './dashboard';
import { aiPersonality } from './aiPersonality';
import { topbar } from './topbar';
import { phoneRecords } from './phoneRecords';

export default {
  common,
  sidebar,
  dashboard,
  aiPersonality,
  topbar,
  phoneRecords,
};
